import { Button, Grid, Divider } from "@mui/material";
import { FieldArray, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { PhoneLandInput, TextInput } from "../../../../components";
import InvoiceGroupInput from "./InvoiceGroupInput";
import { paymentTypeEnum } from "../../../../utils/enum";

const PRIPhoneNumbers = () => {
  const { t } = useTranslation();
  const formik: any = useFormikContext();
  return (
    <FieldArray
      name="pri"
      render={(arrayHelpers) => (
        <Grid item md={12}>
          {formik.values?.pri?.length > 0 &&
            formik.values.paymentType !== paymentTypeEnum.new &&
            formik.values?.pri?.map((doc: any, index: any) => (
              <Grid container spacing={3}>
                <Grid item md={4}>
                  <TextInput
                    name={`pri.${index}.phone`}
                    label={t("pilotNumber")}
                  />
                </Grid>
                <Grid item md={6}>
                  <PhoneLandInput
                    name={`pri.${index}.block`}
                    label={t("land_phone")}
                    handleChange={(e: any) => {
                      formik.setFieldValue(
                        `pri.${index}.block`,
                        e.target.value.replace(/\D/g, "") // removes all non-numeric characters
                      );
                    }}
                  />
                </Grid>
                {/* <Grid item md={2}>
                  <TextInput
                    name={`pri.${index}.didcount`}
                    label={t("didCount")}
                  />
                </Grid> */}
                {/* <Grid item md={4}>
                   <InvoiceGroupInput
                    name={`pri.${index}.invoiceGroupId`}
                    customName={formik?.values?.pri[index]?.invoiceGroupId}
                  />
                </Grid> */}
                <Grid item md={1}>
                  <Button
                    variant="outlined"
                    color="primary"
                    type="button"
                    fullWidth
                    sx={{ height: "50px" }}
                    onClick={() =>
                      arrayHelpers.insert(formik.values.pri.length, {
                        phone: "",
                        block: "",
                        didcount: "",
                      })
                    } // insert an empty string at a position
                  >
                    +
                  </Button>
                </Grid>
                <Grid item md={1}>
                  {/* {index > 0 && (
                      
                    )} */}
                  <Button
                    variant="outlined"
                    color="error"
                    type="button"
                    fullWidth
                    sx={{ height: "50px" }}
                    onClick={() => {
                      if (index <= 0) {
                        arrayHelpers.remove(index);
                      } else {
                        Swal.fire({
                          title: "Lütfen dosya tipi ve dosya ekleyiniz.",
                        });
                      }
                    }} // remove a friend from the list
                  >
                    Sil
                  </Button>
                </Grid>
                <Grid item md={12} sx={{ marginBottom: "15px" }}>
                  <Divider />
                </Grid>
              </Grid>
            ))}
        </Grid>
      )}
    />
  );
};

export default PRIPhoneNumbers;
